/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngxs/store';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';
import { pageKind } from './@core/models/page-kind';
import { SetIcons, SetProducts, SetCategories, SetAccount } from './store/actions/camera.actions';
import { IconsService } from './@core/data/icons-service';
import { UploadService } from './@core/data/upload-service';
import { ProductsService } from './@core/data/products-service';
import { CategoriesService } from './@core/data/categories-service';
import { UserService } from './@core/data/user.service';
import { Account } from './@core/models/account-model';
import { environment } from '../environments/environment';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  selected = 'Nederlands';
  navbar = 1;
  userAccount: Account = new Account();
  delete1: Subscription;
  
  constructor(private store: Store,
              private translate: TranslateService,
              private location: Location,
              private router: Router,
              private iconService: IconsService,
              private productService: ProductsService,
              private userService: UserService,
              private categoriesService: CategoriesService,
              private uploadService: UploadService) { }

  ngOnDestroy(): void {
    throw new Error("Method not implemented.");
  }

  ngOnInit(): void {
    // Home or Webshop?
    this.delete1 = this.router.events.subscribe(() => {
      if (this.location.path() === '/home/home') {
        this.navbar = pageKind.FullNavbar;
      } else if (this.location.path() === '/cookie' || this.location.path() === '/privacy') {
        this.navbar = pageKind.Navbar;
      } else {
        this.navbar = pageKind.NoNavbar;
      }
    });

    this.translate.addLangs(['en', 'fr', 'nl']);
    this.translate.setDefaultLang('nl');
    const browserLang = this.translate.getBrowserLang();
    this.translate.use(browserLang.match(/en|fr|nl/) ? browserLang : 'nl');
    this.selected = this.translate.currentLang;
    this.userAccount.isAdmin = false;
    this.userAccount.canBuy = false;

    this.userService.isLoggedIn().subscribe((isLoggedIn: boolean) => {
      if (isLoggedIn) {
        this.userService.getCurrentUser().then(user => {
          this.userAccount.uid = user.uid;
          this.userAccount.name = user.displayName;
          if (user.email == environment.infoAccount || user.email == environment.infoAccount2) {
            this.userAccount.isAdmin = true;
          }
          this.userService.getLocalUser(user.uid).subscribe(localUser => {
            this.userAccount.name = localUser.displayName;
            this.userAccount.canBuy = localUser.canBuy;
            this.productService.getProducts().subscribe((result) => {
              result.forEach(element => {
                if (this.userAccount.canBuy === false) {
                  element.price = 0;
                }
                this.uploadService.getFIle('products',element.imageBlack).then((link:string) =>{
                  element.pictureLink1 = link;
                  if (element.imageWhite && element.imageWhite !== '') {
                    this.uploadService.getFIle('products',element.imageWhite).then((link:string) =>{
                      element.pictureLink2 = link;
                      this.store.dispatch(new SetProducts(result));
                    }).catch(() => {
                      console.log('NOT FOUND');
                    });;
                  } else {
                    this.store.dispatch(new SetProducts(result));
                  }
                 }).catch(() => {
                  this.store.dispatch(new SetProducts(result));
                   console.log('NOT FOUND');
                 });
              });
            });
          });
        });
      } else {
        this.productService.getProducts().subscribe((result) => {
          result.forEach(element => {
            element.price = 0;
            this.uploadService.getFIle('products',element.imageBlack).then((link:string) =>{
              element.pictureLink1 = link;
              if (element.imageWhite && element.imageWhite !== '') {
                this.uploadService.getFIle('products',element.imageWhite).then((link:string) =>{
                  element.pictureLink2 = link;
                  this.store.dispatch(new SetProducts(result));
                }).catch(() => {
                  console.log('NOT FOUND');
                });;
              } else {
                this.store.dispatch(new SetProducts(result));
              }
             }).catch(() => {
              this.store.dispatch(new SetProducts(result));
               console.log('NOT FOUND');
             });
          });
        });
      }
      this.store.dispatch(new SetAccount(this.userAccount));
    });

    this.iconService.getIcons().subscribe((result) => {
      result.forEach(element => {
        this.uploadService.getFIle('icons',element.image).then((link:string) =>{
          element.link = link;
          this.store.dispatch(new SetIcons(result));
        }).catch(() => {
          this.store.dispatch(new SetIcons(result));
           console.log('NOT FOUND');
         });
      });
    });

    this.categoriesService.getCategories().subscribe((result) => {
      this.store.dispatch(new SetCategories(result));
    });
  }

  onActivate() {
    window.scroll(0, 0);
}

  goToLink(url: string) {
    window.open(url, '_blank');
  }

  mailTo() {
    const mailto = 'mailto:info@fg-security.com';
    window.location.href = mailto;
  }

  selectLanguage($event) {
    this.translate.use($event.value);
  }
}
